/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actual_Male_Cockroach_MendInputs */

const fr_actual_male_cockroach_mend = /** @type {(inputs: Actual_Male_Cockroach_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

/**

* @param {Actual_Male_Cockroach_MendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const actual_male_cockroach_mend = /** @type {((inputs?: Actual_Male_Cockroach_MendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actual_Male_Cockroach_MendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_actual_male_cockroach_mend(inputs)
});